import { theme } from "antd";

const FONT_FAMILY = "'DM Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif";
const FONT_FAMILY_CODE = "monospace";

const sharedTokens = {
  colorPrimary: "#c8a55a",
  colorPrimaryHover: "#d4b36a",
  colorPrimaryActive: "#a6863e",
  colorSuccess: "#16a34a",
  colorError: "#dc2626",
  colorWarning: "#faad14",
  colorBgLayout: "#f4f5f7",
  colorBgContainer: "#ffffff",
  colorBorder: "#e5e7eb",
  colorBorderSecondary: "#f3f4f6",
  colorText: "#1f2937",
  colorTextSecondary: "#6b7280",
  colorTextTertiary: "#374151",
  colorTextQuaternary: "#9ca3af",
  fontFamily: FONT_FAMILY,
  fontFamilyCode: FONT_FAMILY_CODE,
  fontSize: 14,
  borderRadius: 8,
  borderRadiusLG: 10,
  borderRadiusXL: 12,
  borderRadiusSM: 6,
};

export const lightTheme = {
  token: {
    ...sharedTokens,
    padding: 16,
  },
  components: {
    Table: {
      headerBg: "#f8f9fb",
      headerColor: "#6b7280",
      headerSortActiveBg: "#f0f1f3",
      rowHoverBg: "#fafbfc",
      borderColor: "#f3f4f6",
      headerBorderRadius: 10,
      fontSize: 14,
    },
    Card: {
      borderRadiusLG: 10,
      colorBorderSecondary: "#e5e7eb",
    },
    Tag: {
      borderRadiusSM: 6,
      fontSize: 12,
      defaultBg: "#f0f1f3",
      defaultColor: "#0b1426",
    },
    Input: {
      borderRadius: 8,
      paddingInline: 14,
      paddingBlock: 10,
      fontSize: 15,
      colorTextPlaceholder: "#9ca3af",
      colorIcon: "#b0b5be",
    },
    Button: {
      borderRadius: 8,
      contentFontSizeLG: 15,
      fontWeight: 600,
      defaultHeight: 40,
    },
    Menu: {
      darkItemBg: "transparent",
      darkItemSelectedBg: "rgba(200, 165, 90, 0.12)",
      darkItemHoverBg: "rgba(200, 165, 90, 0.06)",
      darkItemColor: "rgba(255, 255, 255, 0.55)",
      darkItemHoverColor: "rgba(255, 255, 255, 0.85)",
      darkItemSelectedColor: "#c8a55a",
      itemMarginInline: 8,
      itemMarginBlock: 2,
      itemHeight: 42,
      fontSize: 14,
      iconSize: 16,
    },
    Modal: {
      borderRadiusLG: 12,
    },
    Drawer: {
      borderRadiusLG: 12,
    },
    Statistic: {
      fontSize: 20,
      titleFontSize: 13,
    },
    Message: {
      borderRadiusLG: 8,
    },
  },
};

export const darkTheme = {
  algorithm: [theme.darkAlgorithm],
  token: {
    ...sharedTokens,
    colorBgLayout: "#0b1426",
    colorBgContainer: "transparent",
    colorBgElevated: "rgba(14, 26, 48, 0.95)",
    colorBorder: "rgba(255, 255, 255, 0.08)",
    colorText: "rgba(255, 255, 255, 0.85)",
    colorTextSecondary: "rgba(255, 255, 255, 0.55)",
    colorTextTertiary: "rgba(255, 255, 255, 0.45)",
    colorTextQuaternary: "rgba(255, 255, 255, 0.25)",
  },
  components: {
    Input: {
      borderRadius: 8,
      paddingInline: 14,
      paddingBlock: 10,
      fontSize: 15,
      colorBgContainer: "rgba(255, 255, 255, 0.06)",
      colorBorder: "rgba(255, 255, 255, 0.1)",
      colorTextPlaceholder: "rgba(255, 255, 255, 0.35)",
      colorIcon: "#b0b5be",
    },
    Button: {
      borderRadius: 8,
      contentFontSizeLG: 15,
      fontWeight: 600,
      defaultHeight: 44,
      primaryShadow: "0 1px 2px rgba(200, 165, 90, 0.2)",
    },
    Card: {
      colorBorderSecondary: "rgba(255, 255, 255, 0.08)",
      colorBgContainer: "rgba(14, 26, 48, 0.6)",
    },
    Form: {
      labelColor: "rgba(255, 255, 255, 0.65)",
      labelFontSize: 14,
    },
  },
};
